export const INTERNAL_MESSAGE_TYPE = Object.freeze({
  transactional: 'transactional',
  marketing: 'marketing',
});

export const TARGET_TYPE = Object.freeze({
  all: 'all',
  filter: 'filter',
  specific: 'specific',
});

export function buildEmptyCreateForm(prefilledProfileUid = null) {
  return {
    subject: '',
    body: '',
    type: INTERNAL_MESSAGE_TYPE.transactional,
    targetType: prefilledProfileUid ? TARGET_TYPE.specific : TARGET_TYPE.all,
    targetProfileUid: prefilledProfileUid || '',
    targetCountries: [],
    targetAccountTypes: [],
    targetProfileStatuses: [],
  };
}

export function buildCreatePayload(form) {
  const payload = {
    subject: form.subject.trim(),
    body: form.body.trim(),
    type: String(form.type || INTERNAL_MESSAGE_TYPE.transactional).trim() || INTERNAL_MESSAGE_TYPE.transactional,
  };

  if (form.targetType === TARGET_TYPE.specific && form.targetProfileUid.trim()) {
    payload.targetProfileUid = form.targetProfileUid.trim();
  } else if (form.targetType === TARGET_TYPE.filter) {
    if (form.targetCountries.length > 0) {
      payload.targetCountries = form.targetCountries;
    }
    if (form.targetAccountTypes.length > 0) {
      payload.targetAccountTypes = form.targetAccountTypes;
    }
    if (form.targetProfileStatuses.length > 0) {
      payload.targetProfileStatuses = form.targetProfileStatuses;
    }
  }

  return payload;
}

export function validateCreateForm(form) {
  const errors = {};
  if (!form.subject.trim()) {
    errors.subject = 'Subject is required';
  }
  if (!form.body.trim()) {
    errors.body = 'Body is required';
  }
  if (!String(form.type || '').trim()) {
    errors.type = 'Message type is required';
  }
  if (form.targetType === TARGET_TYPE.specific && !form.targetProfileUid.trim()) {
    errors.targetProfileUid = 'Profile UID is required for specific targeting';
  }
  return errors;
}
